/* Users in order to get some random id */
export const generateId = () => Math.random().toString(36).substr(2, 9);